
  import { computed, defineComponent } from 'vue';
  import { Button } from '@/ui/components/Button';
  import { TOTAL_STEPS } from '@/entities/onboarding';
  import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';

  interface OnboardingPageNavigationProps {
    canContinue: boolean;
    isLastStep: boolean;
    step: number;
  }

  export default defineComponent<OnboardingPageNavigationProps>({
    components: {
      Button,
    },
    props: ['canContinue', 'step', 'isLastStep'],
    emits: ['skip', 'continue'],
    setup(props, context) {
      const continueAction = () => {
        if (props.canContinue) {
          trackClick({
            ...CLICK_EVENTS.CONTINUE_SEGMENTATION_STEP,
          });

          context.emit('continue');
        }
      };
      const skipAction = () => {
        trackClick({
          ...CLICK_EVENTS.SKIP_SEGMENTATION_STEP,
        });

        context.emit('skip');
      };
      const hasNextStep = computed(() => {
        return props.step < TOTAL_STEPS;
      });

      return {
        continueAction,
        skipAction,
        hasNextStep,
      };
    },
  });
